import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, FormBuilder} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingViajes } from '../../model/modelTracking';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { IAreaLogistica } from '../../model/modelConfiguracional';
import { ColDef, ColGroupDef, GridApi, GridOptions, CsvExportModule} from 'ag-grid-community';
import { ClaveValorModel } from 'src/app/model/datos-maestros/claveValorModel';

@Component({
  selector: 'app-areas-logistica',
  templateUrl: './areas-logistica.component.html',
  styleUrls: ['./areas-logistica.component.css']
})

export class AreasLogisticaComponent implements OnInit {
 
  public DAT_TITULOS    = diccionarios.titulos.areas;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  //Variables para el Grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public defaultColDef  : ColDef;
  public gridApi        : GridApi;
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;

  // Variables funcionales
  public cmbxEstados    : ClaveValorModel[] = [];
  public cmbxTipoArea   : ClaveValorModel[] = [];

  public selected       : ITrackingViajes;
  public listCentros    : CentroAlmacen [] = [];

  public usarioActual   : any;
  public fechaHoraInicio: any;
  
  //Formularios
  public formulario: FormGroup;
  
  constructor(
    private utilServices    : UtilsService,
    private dmaestrosAPI    : DatosMaestrosService,
    private _catalogos      : CatalogosLogisticaService,
    private fbServices      : FormBuilder,
    private trackingConfiguracional: TrackingConfiguracionService,
  ) { }

  ngOnInit(): void {
    this.formulario = this.fbServices.group({
      idArea              : [''],
      descArea            : ['', [Validators.required]],
      tipoArea            : ['', [Validators.required]],
      centro              : ['', [Validators.required]],
      color               : ['', [Validators.required]],
      nomeclatura         : ['', [Validators.required, Validators.maxLength(5)]],
      capacidadTotal      : ['', [Validators.required]],
      capacidadActual     : [''],
      disponibilidad      : [''],

      aplicaExcepcion     : [''],
      capacidadExcepcion  : [''],
      fechaInicio         : [''],
      fechaFin            : [''],

      estado              : ['', [Validators.required]],
      creadoPor           : [''],
      modificadoPor       : [''],
      creado              : [],
      modificado          : [],
    });

    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.cargarGridcomponent();
    this.inicializar();
  }

  fechaInicioProceso(){
   this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [      
      { field: 'idArea', sort: "DESC"},
      { field: 'nomeclatura' },
      { field: 'descArea' },
      { field: 'tipoArea' },
      { field: 'centro' },
      { field: 'capacidadTotal' },
      { field: 'color', cellStyle: params => {return { backgroundColor: params.value}}},
      { field: 'estado' },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.editar.bind(this), label: 'Editar'} },
      { cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.delete.bind(this), label: 'Eliminar'} }
    ];
    
    this.defaultColDef = this._catalogos.getDefaultColDef();
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  
  onBtnExport() {
    this.gridApi.exportDataAsCsv();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  inicializar(){
    this.cmbxTipoArea = this._catalogos.catalogoTipoArea();
    this.cmbxEstados  = this._catalogos.catalogoEstadoLogico();
    this.listCentros  = [];
  
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res) => {
      if(res)this.listCentros = res.map((e)=> {e.nombreCentro = e.idCentro +" - "+e.nombreCentro; return e});
    }, (err) => { 
      console.log(err.message); 
    });

    this.listar();
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;

    this.formulario.reset();
    this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
    this.formulario.get('estado').setValue(1);
    this.fechaInicioProceso();

    this.openModal();
  }

  editar({rowData}){
    this.isCreate  = false;
    this.selected = rowData;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;

    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.formulario.get('estado').setValue(rowData.estado == "A" ? 1 : 0);
    this.formulario.get('aplicaExcepcion').setValue(rowData.capacidadExcepcion >0 ? true : false);
    
    this.openModal();
  }

  listar(){
    this.rowData = [];
    this.trackingConfiguracional.getAllAreas().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => { 
      console.log(err.message); 
    });    
  }

  /** Si el form esta en modo de creación ejecuta post caso contrario un put. 
   * Ver estado variable isCreated 
   * */
  saveForm() {
    //this.getFormValidationErrors();
    if (this.formulario.invalid) return;
    this.loading  = true;
    
    let mensajeP  = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    let data = this.formulario.getRawValue();
    data.estado =  data.estado === 1 ? "A" : "I";
    data.modificadoPor = !this.isCreate ? this.usarioActual.login2 : data.modificadoPor ;
    
    if( data.capacidadExcepcion && (data.fechaHoraInicio == null || data.fechaFin == null)){
        this.utilServices.mensajeErrorVisto("Debe llenar todos los datos de Exepción", false, 5000);
        this.loading = false;
        return
    }
    const payload =  data;
    console.log("datos a enviar", payload);  

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.trackingConfiguracional.saveAreas(payload) : this.trackingConfiguracional.updateAreas(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  //Borrado logico solo inactiva el registro
  delete({rowData}){
    this.loading = true;
    rowData.estado = "I";

    this.utilServices.confirmarSincronoPromesa({
        title : diccionarios.mensajes.eliminar,
        text  : this.GLOBAL_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.trackingConfiguracional.updateAreas(rowData),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  validaciones(){
    if(this.formulario.get('capacidadExcepcion').value > 0){
        this.formulario.get('fechaInicio').reset();
        this.formulario.get('fechaInicio').reset();
    }
  }

  //Función de copiado de grid
  copy(){
    const texto = this.utilServices.jsonToCsv(this.gridApi.getSelectedRows());
    navigator.clipboard.writeText(texto)
      .then(() => console.log('Copiado al portapapeles'))
      .catch(err => console.error('Error al copiar:', err));
  }

}